const radius = {
  xxs: '2px',
  xs: '4px',
  s: '6px',
  m: '8px',
  l: '12px',
  pill: '100px',
}

export default radius



// WEBPACK FOOTER //
// ./src/global/borderRadius.js